import { Col, Row } from '@rematter/ui-web';
import { cn } from '@rematter/ui-web';

import { FinanceEventDetail } from './FinanceEventDetail';
import { FinanceEventsList } from './FinanceEventsList';
import { FinanceEventsSidebar } from './FinanceEventsSidebar';

import { useFinanceAuditTab } from '@/audit-log/_state/financeEvents.state';
import { useTranslations } from '@/audit-log/i18n/useTranslations';

export const FinanceEventsView = () => {
  const t = useTranslations();
  const [tab, setTab] = useFinanceAuditTab();

  return (
    <Col className="@FinanceEventsView size-full">
      <Row className="border-b border-neutral/10 px-4">
        <button
          onClick={() => setTab('events')}
          className={cn(
            'px-4 py-3 text-sm font-medium transition-colors',
            tab === 'events'
              ? 'border-b-2 border-primary text-primary'
              : 'text-neutral/60 hover:text-neutral',
          )}
        >
          {t.financeEventsView.tabs.events}
        </button>
        <button
          onClick={() => setTab('inbox')}
          disabled
          className={cn(
            'px-4 py-3 text-sm font-medium transition-colors',
            tab === 'inbox'
              ? 'border-b-2 border-primary text-primary'
              : 'cursor-not-allowed text-neutral/30',
          )}
        >
          {t.financeEventsView.tabs.inbox}
        </button>
      </Row>
      <Row className="flex-1 items-stretch overflow-hidden">
        <FinanceEventsSidebar />
        <FinanceEventsList />
        <FinanceEventDetail />
      </Row>
    </Col>
  );
};
